<template>
  <div
    class="rounded-[12px] p-5 relative overflow-hidden border border-[#F0F0F0]"
    :style="{ backgroundColor: bgColor }"
    :data-testid="testId"
  >
    <div
      class="absolute left-0 top-0 bottom-0 w-1"
      :style="{ backgroundColor: stripeColor }"
      aria-hidden="true"
    />
    <div class="ml-2">
      <p
        class="text-[13px] uppercase tracking-wider font-medium mb-4 m-0"
        :style="{ color: labelColor }"
      >
        {{ label }}
      </p>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImpactStageSection',
  props: {
    label: { type: String, required: true },
    stripeColor: { type: String, default: '#E5E5E5' },
    bgColor: { type: String, default: '#FFFFFF' },
    testId: { type: String, default: 'impact-stage-section' },
  },
  computed: {
    labelColor() {
      return this.stripeColor === '#E5E5E5' ? '#ABABAB' : this.stripeColor;
    },
  },
};
</script>
